import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (20 / 24);
  const localHeight = size * (19.462 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 20 19.462">
      <path
        d="M2.376,19.275a.743.743,0,0,1-.158-.882l1.538-3.026A4.869,4.869,0,0,1,0,10.595V4.884A4.836,4.836,0,0,1,4.774,0H15.226A4.836,4.836,0,0,1,20,4.884v5.71a4.836,4.836,0,0,1-4.774,4.884H8.873L3.251,19.338a.7.7,0,0,1-.875-.062ZM1.43,4.884v5.71a3.388,3.388,0,0,0,3.344,3.422h.1a.712.712,0,0,1,.611.351.746.746,0,0,1,.023.717l-.734,1.444,3.481-2.389a.7.7,0,0,1,.4-.124h6.57a3.388,3.388,0,0,0,3.344-3.422V4.884a3.387,3.387,0,0,0-3.344-3.422H4.774A3.387,3.387,0,0,0,1.43,4.884ZM5.073,10.5a.686.686,0,0,1,0-1.371H15.05a.686.686,0,0,1,0,1.371Zm0-3.657a.686.686,0,0,1,0-1.372H15.05a.686.686,0,0,1,0,1.372Z"
        transform="translate(0 0)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
